import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { EProductTemplatesListItem } from '@api-ui-app/src/app/e-commerce-product-templates/types/e-product-templates-list-item';
import { ShowNotification } from '@gelato-api-ui/ui-kit/src/lib/notification/notification.actions';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'gd-product-templates-list-item',
  templateUrl: './product-templates-list-item.component.html',
  styleUrls: ['./product-templates-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductTemplatesListItemComponent {
  @Input() item: EProductTemplatesListItem;
  @Input() showPlaceOrderButton = true;
  @Input() showEditButton = true;
  @Input() showActionButtons = true;
  @Output() placeOrderButtonClick = new EventEmitter<void>();
  @Output() addToStoreButtonClick = new EventEmitter<void>();
  @Output() editButtonClick = new EventEmitter<void>();
  @Output() renameButtonClick = new EventEmitter<void>();
  @Output() duplicateButtonClick = new EventEmitter<void>();
  @Output() deleteButtonClick = new EventEmitter<void>();
  @Output() itemClick = new EventEmitter<EProductTemplatesListItem>();

  constructor(private readonly store: Store, private readonly translateService: TranslateService) {}

  onPlaceOrderButtonClick() {
    this.placeOrderButtonClick.emit();
  }

  onAddToStoreButtonClick() {
    this.addToStoreButtonClick.emit();
  }

  onEditButtonClick() {
    this.editButtonClick.emit();
  }

  onRenameButtonClick() {
    this.renameButtonClick.emit();
  }

  onDuplicateButtonClick() {
    this.duplicateButtonClick.emit();
  }

  onDeleteButtonClick() {
    this.deleteButtonClick.emit();
  }

  copyTemplateId() {
    const message = this.translateService.instant('txt_template_id_copied_to_clipboard');

    this.store.dispatch(new ShowNotification({ message }));
  }
}
